import { lazy } from "react";

const routes = [
  {
    name: "login",
    path: "/",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "login",
    path: "/:token",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "forgotPassword",
    path: "/forgot-password",
    component: lazy(() => import("../modules/ForgotPassword/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "resetPassword",
    path: "/reset-password",
    component: lazy(() => import("../modules/ResetPassword/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "signin",
    path: "/signin",
    component: lazy(() => import("../modules/Login/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "registerCompany",
    path: "/register-company",
    component: lazy(() => import("../modules/RegisterCompany/index.js")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "dashboard",
    path: `/admin/dashboard`,
    component: lazy(() => import("../modules/DashboardModule/DashboardModuleForAdmin.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AdminLayout",
  },
  {
    name: "products",
    path: `/weekmateProducts`,
    component: lazy(() => import("../modules/ProductsPage/ProductPicker.js")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "AuthLayout",
  },
  // {
  //   name: "manage",
  //   path: `/admin/manageUsers`,
  //   component: lazy(() => import("../modules/ManageUsers/manageUsers.js")),
  //   exact: true,
  //   wrapRoute: "ProtectedRoute",
  //   layout: "AdminLayout",
  // }
];

export default routes;